import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Dashboard from "./components/Dashboard";
import TaskManager from "./components/TaskManager";
import Calendar from "./components/Calendar";
import Settings from "./components/Settings";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Language Context
const LanguageContext = React.createContext();

function App() {
  const [language, setLanguage] = useState('ar');
  const [tasks, setTasks] = useState([]);
  const [dashboardStats, setDashboardStats] = useState({
    total_tasks: 0,
    completed_tasks: 0,
    pending_tasks: 0,
    overdue_tasks: 0,
    today_tasks: 0,
    this_week_tasks: 0
  });

  // Translations
  const translations = {
    ar: {
      appName: "مركز إنتاجية المشولي",
      dashboard: "لوحة التحكم",
      tasks: "المهام",
      calendar: "التقويم",
      settings: "الإعدادات",
      totalTasks: "إجمالي المهام",
      completedTasks: "المهام المكتملة",
      pendingTasks: "المهام المعلقة",
      overdueTasks: "المهام المتأخرة",
      todayTasks: "مهام اليوم",
      weekTasks: "مهام الأسبوع",
      newTask: "مهمة جديدة",
      taskTitle: "عنوان المهمة",
      taskDescription: "وصف المهمة",
      category: "الفئة",
      priority: "الأولوية",
      dueDate: "تاريخ الاستحقاق",
      save: "حفظ",
      cancel: "إلغاء",
      edit: "تعديل",
      delete: "حذف",
      markCompleted: "وضع علامة مكتمل",
      // Categories
      meeting: "اجتماع",
      followup: "متابعة",
      directive: "توجيه",
      email: "بريد",
      note: "ملاحظة",
      other: "أخرى",
      // Priorities
      high: "عالية",
      medium: "متوسطة",
      low: "منخفضة",
      // Status
      pending: "معلقة",
      in_progress: "قيد التنفيذ",
      completed: "مكتملة",
      cancelled: "ملغية"
    },
    en: {
      appName: "Almashwaly Productivity Hub",
      dashboard: "Dashboard",
      tasks: "Tasks",
      calendar: "Calendar",
      settings: "Settings",
      totalTasks: "Total Tasks",
      completedTasks: "Completed Tasks",
      pendingTasks: "Pending Tasks",
      overdueTasks: "Overdue Tasks",
      todayTasks: "Today's Tasks",
      weekTasks: "This Week's Tasks",
      newTask: "New Task",
      taskTitle: "Task Title",
      taskDescription: "Task Description",
      category: "Category",
      priority: "Priority",
      dueDate: "Due Date",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      markCompleted: "Mark Completed",
      // Categories
      meeting: "Meeting",
      followup: "Follow-up",
      directive: "Directive",
      email: "Email",
      note: "Note",
      other: "Other",
      // Priorities
      high: "High",
      medium: "Medium",
      low: "Low",
      // Status
      pending: "Pending",
      in_progress: "In Progress",
      completed: "Completed",
      cancelled: "Cancelled"
    }
  };

  const t = (key) => translations[language][key] || key;

  // Fetch dashboard data
  const fetchDashboardStats = async () => {
    try {
      const response = await axios.get(`${API}/dashboard`);
      setDashboardStats(response.data);
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
    }
  };

  // Fetch tasks
  const fetchTasks = async () => {
    try {
      const response = await axios.get(`${API}/tasks`);
      setTasks(response.data);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    }
  };

  useEffect(() => {
    fetchDashboardStats();
    fetchTasks();
  }, []);

  const contextValue = {
    language,
    setLanguage,
    t,
    tasks,
    setTasks,
    dashboardStats,
    fetchDashboardStats,
    fetchTasks,
    API
  };

  return (
    <LanguageContext.Provider value={contextValue}>
      <div className={`App ${language === 'ar' ? 'rtl' : 'ltr'}`}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/tasks" element={<TaskManager />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageContext.Provider>
  );
}

export { LanguageContext };
export default App;